import { AxiosPromise } from 'axios';
import { ApiService } from 'app/services/api.service';
import { CalculationDataByModelPathsInterface } from 'app/shared/interfaces/CalculationDataByModelPaths.interface';
import { HiProApplicationResponseInterface } from 'app/shared/interfaces/HiProApplicationResponse.interface';
import { BeginHiProPaymentApplicationRequestDto } from 'app/components/MubiInstallmentsModal/MubiInstallmentsModalViews/ApplicationDataForm/ApplicationDataForm.interfaces';
import { HiProDecisionDto } from 'app/components/MubiInstallmentsModal/MubiInstallmentsModalViews/Verification/Verification.interfaces';

export const HiProPaymentService = {
  beginHiProPayment({
    token,
    data,
  }: {
    token: string;
    data: BeginHiProPaymentApplicationRequestDto;
  }): AxiosPromise {
    return ApiService.patch(`payments/hipro/${token}`, data);
  },

  verificationHiProApplicationSms({
    smsValue,
    token,
  }: {
    smsValue: string;
    token: string;
  }): AxiosPromise {
    return ApiService.patch(`payments/hipro/applications/${token}`, {
      pin: smsValue,
    });
  },

  retryGetSmsCode({ token }: { token: string }): AxiosPromise {
    return ApiService.get(`payments/hipro/${token}`);
  },

  confirmHiProContractSms({
    smsValue,
    token,
  }: {
    smsValue: string;
    token: string;
  }): AxiosPromise {
    return ApiService.patch(`payments/hipro/contracts/${token}`, {
      pin: smsValue,
    });
  },

  getHiProCreditDecision({
    token,
  }: {
    token: string;
  }): AxiosPromise<HiProDecisionDto> {
    return ApiService.get(`payments/hipro/decisions/${token}`);
  },

  registerHiProPayment({
    resultId,
    offerId,
    quotation,
    hiProConsentGranted,
    policyConversionId,
  }: {
    resultId: string;
    offerId: string;
    quotation: CalculationDataByModelPathsInterface;
    hiProConsentGranted: boolean;
    policyConversionId?: string;
  }): AxiosPromise<HiProApplicationResponseInterface> {
    const data = {
      quotation,
      hiProConsentGranted,
      ...(policyConversionId && { policyConversionId }),
    };

    return ApiService.post(
      `car-insurances/quotations/quotation-results/${resultId}/offers/${offerId}/hipro-payments`,
      data
    );
  },
};
